import { useState } from 'react';
import type { Repo } from '../data/repo';
import { errorMessage } from '../data/repo';
import { enterDemo } from '../data/mode';

export function SignIn({ repo }: { repo: Repo }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function run(fn: () => Promise<void>, ok?: string) {
    setBusy(true);
    setStatus(null);
    try { await fn(); if (ok) setStatus(ok); } catch (e) { setStatus(errorMessage(e)); } finally { setBusy(false); }
  }

  return (
    <main className="gate">
      <form className="panel gate-card" onSubmit={(e) => { e.preventDefault(); void run(() => repo.signIn(email, password)); }}>
        <span className="kicker">Private access</span>
        <h1>Finance <span>Cockpit</span></h1>
        <p className="muted">No financial data is shown until you sign in.</p>
        <label htmlFor="email">Email</label>
        <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <label htmlFor="password">Password</label>
        <input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="cta" type="submit" disabled={busy || !email || !password}>Sign in</button>
        <button className="link" type="button" disabled={busy || !email}
          onClick={() => void run(() => repo.sendMagicLink(email), 'Check your email for a sign-in link.')}>
          Email me a sign-in link instead
        </button>
        {status && <p className="status-line" role="status">{status}</p>}
        <hr />
        <button className="secondary" type="button" onClick={() => void enterDemo(() => repo.signOut())}>Explore Demo Mode (synthetic data)</button>
      </form>
    </main>
  );
}
